<template>
  <section class="custom-photo-wrapper">
    <div v-if="isAssessment" class="row justify-content-center">
      <div v-if="tookPhoto" class="col-4">
        <button
          class="btn btn-primary btn-sm me-2"
          :disabled="isSaving"
          @click="saveThePhotos"
        >
          <i v-if="isSaving" class="fas fa-spinner fa-spin me-2"></i>
          Save Photos
        </button>
        <button
          class="btn btn-secondary btn-sm"
          :disabled="isSaving"
          @click="cancelPhotoSave"
        >
          Cancel
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <table class="custom-table">
          <tr>
            <th></th>
            <th></th>
            <th v-for="(item, idx) of selected" :key="idx" class="text-center">
              {{ item.date }}
            </th>
          </tr>
          <tr v-for="row of rows" :key="row.id">
            <td class="custom-badge">
              <span
                class="badge rounded-pill custom-pill custom-pill-position"
                >{{ row.id }}</span
              >
              <img
                :src="row.image"
                class="custom-image"
                :class="{ 'custom-image-2': row.id > 3 }"
              />
              <a
                v-if="(!anySelected || tookPhoto) && !isSaving && isAssessment"
                href="#"
                @click="takePhoto(row.id)"
                class="custom-camera"
                title="Snap this photo profile as of today"
              >
                <i class="fas fa-camera"></i>
              </a>
            </td>
            <td class="custom-name-position">
              {{ row.name }}
            </td>
            <td v-for="(item, idx) of selected" :key="idx" class="text-center">
              <a @click="showPhoto(row, item)" class="custom-image-action">
                <img :src="getImage(row, item)" class="custom-image-3" />
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </section>
  <photo-dialog :show="actionPhotos" @close="closeDialog" />
  <take-photo-dialog
    ref="takePhoto"
    :show="actionTakePhoto"
    @save="addPhoto"
    @close="closeDialog"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import globals from '@/Plugins/globals'
import PhotoDialog from '../client/client-measurement-photo-dialog'
import TakePhotoDialog from '../client/client-measurement-take-photo-dialog'
export default {
  name: 'measurement-photos',
  components: {
    PhotoDialog,
    TakePhotoDialog,
  },
  data() {
    return {
      actionPhotos: null,
      actionTakePhoto: null,
      rows: [
        {
          id: 1,
          name: 'Front with arms at side, palms up',
          value: '',
          image: '/media/front.png',
          code: 'front',
        },
        {
          id: 2,
          name: 'Back with arms down',
          value: '',
          image: '/media/back.png',
          code: 'back_arms_down',
        },
        {
          id: 3,
          name: 'Side profile with torso slightly twisted to front',
          value: '',
          image: '/media/side.png',
          code: 'side_profile',
        },
        {
          id: 4,
          name: 'Back with arms up, flexed double bicep',
          value: '',
          image: '/media/back-biceps.png',
          code: 'back_double_bicep',
        },
        {
          id: 5,
          name: 'Front with arms up, flexed double bicep',
          value: '',
          image: '/media/front-biceps.png',
          code: 'front_double_bicep',
        },
      ],
      tookPhoto: false,
      isSaving: false,
    }
  },
  emits: ['reload'],
  mounted() {
    this.tookPhoto = false
    this.isSaving = false
  },
  computed: {
    ...mapGetters('measurements', ['photos']),
    ...mapGetters('usercardio', ['member', 'summary']),
    id() {
      let _id = null
      if (this.member) {
        _id = this.member.id
      }
      return _id
    },
    isAssessment() {
      let _is = false
      if (this.summary) {
        if (this.summary.organization) {
          if (parseInt(this.summary.organization.assessmentVisibility) === 1) {
            _is = true
          }
        }
      }
      return _is
    },
    anySelected() {
      let _any = false
      if (this.selected) {
        if (this.selected.length > 0) {
          _any = true
        }
      }
      console.log('Any Selected', this.selected)
      return _any
    },
    selected() {
      let _data = []
      this.photos.forEach((element) => {
        let _rows = JSON.parse(JSON.stringify(this.rows))
        let _missing = '/media/missing.png'
        _rows.forEach((row) => {
          switch (row.id) {
            case 1: {
              row.value = element.front !== '' ? element.front : _missing
              break
            }
            case 2: {
              row.value =
                element.back_arms_down !== ''
                  ? element.back_arms_down
                  : _missing
              break
            }
            case 3: {
              row.value =
                element.side_profile !== '' ? element.side_profile : _missing
              break
            }
            case 4: {
              row.value =
                element.back_double_bicep !== ''
                  ? element.back_double_bicep
                  : _missing
              break
            }
            case 5: {
              row.value =
                element.front_double_bicep !== ''
                  ? element.front_double_bicep
                  : _missing
              break
            }
          }
        })
        if (element.checked) {
          _data.push({
            date: element.date,
            rows: globals.sortArray(_rows, 'photo_date', 'desc'),
          })
        }
      })
      return _data
    },
  },
  methods: {
    ...mapActions('measurements', ['setPhoto', 'savePhotos']),
    closeDialog() {
      if (this.actionTakePhoto !== null) {
        this.$refs.takePhoto.stop()
      }
      this.actionPhotos = null
      this.actionTakePhoto = null
    },
    takePhoto(row) {
      if (this.$refs.takePhoto) {
        this.$refs.takePhoto.init()
      }
      this.actionTakePhoto = {
        rows: this.rows,
        row: row,
      }
    },
    addPhoto(row) {
      this.$refs.takePhoto.stop()
      this.actionTakePhoto = null
      let found = this.rows.find((x) => parseInt(x.id) === parseInt(row.row))
      if (found) {
        let timestamp = moment.utc().valueOf()
        // filename format:  progress_photo_[MemberId][UnixDateTimestamp]_[code].jpg
        let filename = `progress_photo_${this.id}${timestamp}_${found.code}.jpg`
        let img = row.image.replace(/^data:image\/[a-z]+;base64,/, '')
        let data = {
          id: found.id,
          userid: this.id,
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
          code: found.code,
          filename: filename,
          base64Content: img,
          image: row.image,
        }
        console.log('Set Photo', data)
        this.setPhoto(data)
        this.tookPhoto = true
      }
    },
    async saveThePhotos() {
      this.isSaving = true
      let found = this.photos.find((x) => parseInt(x.id) === -99)
      if (found) {
        let data = {
          id: this.id,
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
        }
        // front
        data['front'] = {
          FileName: '',
          base64Content: '',
        }
        if (found.front_data) {
          data['front'] = {
            FileName: found.front_data.filename,
            base64Content: found.front_data.base64,
          }
        }
        // back_arms_down
        data['back_arms_down'] = {
          FileName: '',
          base64Content: '',
        }
        if (found.back_arms_down_data) {
          data['back_arms_down'] = {
            FileName: found.back_arms_down_data.filename,
            base64Content: found.back_arms_down_data.base64,
          }
        }
        // side_profile
        data['side_profile'] = {
          FileName: '',
          base64Content: '',
        }
        if (found.side_profile_data) {
          data['side_profile'] = {
            FileName: found.side_profile_data.filename,
            base64Content: found.side_profile_data.base64,
          }
        }
        // back_double_bicep
        data['back_double_bicep'] = {
          FileName: '',
          base64Content: '',
        }
        if (found.back_double_bicep_data) {
          data['back_double_bicep'] = {
            FileName: found.back_double_bicep_data.filename,
            base64Content: found.back_double_bicep_data.base64,
          }
        }
        // front_double_bicep
        data['front_double_bicep'] = {
          FileName: '',
          base64Content: '',
        }
        if (found.front_double_bicep_data) {
          data['front_double_bicep'] = {
            FileName: found.front_double_bicep_data.filename,
            base64Content: found.front_double_bicep_data.base64,
          }
        }
        console.log('Save Photos to API', data)
        await this.savePhotos(data)
        // await globals.aSleep(2500)
      }
      this.isSaving = false
      this.tookPhoto = false
      this.$emit('reload')
    },
    cancelPhotoSave() {
      this.isSaving = false
      this.tookPhoto = false
      this.$emit('reload')
    },
    showPhoto(row, item) {
      let photos = []
      this.selected.forEach((element) => {
        let found = element.rows.find((x) => x.id === row.id)
        if (found) {
          photos.push({
            date: element.date,
            url: found.value,
          })
        }
      })
      this.actionPhotos = photos
    },
    getImage(row, item) {
      let url = '/media/missing.png'
      let found = item.rows.find((x) => x.id === row.id)
      if (found) {
        url = found.value
      }
      return url
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-photo-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 560px;
}
.custom-table {
  width: 100%;
}
.custom-badge {
  position: relative;
}
.custom-pill {
  color: rgb(197, 128, 0);
  background-color: #c4c4c4 !important;
}
.custom-pill-position {
  position: absolute;
  top: 5px;
  left: 0;
}
.custom-name-position {
  vertical-align: top;
}
.custom-image-action {
  cursor: pointer;
}
.custom-image {
  width: 120px;
  height: 174px;
  padding-left: 20px;
}
.custom-image-2 {
  width: 192px !important;
}
.custom-image-3 {
  width: 120px;
}
.custom-camera {
  cursor: pointer;
  font-size: 1.4em;
  color: #0d6efd;
  position: absolute;
  top: 25px;
  left: 0px;
}
</style>
